export default "__VITE_ASSET__3b7ee98b__"